import { render, staticRenderFns } from "./scheduleClassRecord.vue?vue&type=template&id=4fa05408&"
import script from "./scheduleClassRecord.vue?vue&type=script&lang=js&"
export * from "./scheduleClassRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports